import { GeneralBlock } from 'src/registry/components/blocks/GeneralBlock';
import { SectionBlockSubtitle, SectionBlockTitle } from 'src/registry/components/blocks/SectionBlock';
import { homeMessages } from 'src/features/home/utils/messages';
import StatisticValue from 'src/registry/components/statistic/StatisticValue';
import { useIntl } from 'react-intl';
import { HomeStatistics } from 'src/features/home/types';
import ComparisonBadge from 'src/features/home/components/ComparisonBadge';
import GeneralMessageBlock from 'src/registry/components/blocks/GeneralMessageBlock';

type Props = {
    isLoading?: boolean;
    totalVisits?: HomeStatistics['total_visits'];
    membershipVisits?: HomeStatistics['membership_visits'];
    isError: boolean;
};
export default function WidgetVisits({ isLoading, totalVisits, membershipVisits, isError }: Props) {
    const { formatMessage } = useIntl();

    return (
        <div className="flex flex-1 flex-col gap-6">
            <GeneralBlock className="flex-1 justify-between">
                <div className="flex flex-col">
                    <SectionBlockTitle>{formatMessage(homeMessages.totalVisits)}</SectionBlockTitle>
                    <SectionBlockSubtitle>{formatMessage(homeMessages.totalVisitsDescription)}</SectionBlockSubtitle>
                </div>
                {isError ? (
                    <GeneralMessageBlock className="py-3" variant="error" />
                ) : (
                    <>
                        <div className="flex w-full justify-center gap-5 text-xs">
                            <StatisticValue
                                title={formatMessage(homeMessages.visits)}
                                value={totalVisits?.visits_count}
                                isLoading={isLoading}
                            />
                            <StatisticValue
                                title={formatMessage(homeMessages.visitors)}
                                value={totalVisits?.visitors_count}
                                isLoading={isLoading}
                            />
                        </div>
                        <ComparisonBadge value={totalVisits?.compared_to_last_day} />
                    </>
                )}
                <ComparisonBadge value={totalVisits?.compared_to_last_day} />
            </GeneralBlock>
            <GeneralBlock className="flex-1 justify-between">
                <div className="flex flex-col">
                    <SectionBlockTitle>{formatMessage(homeMessages.membershipVisits)}</SectionBlockTitle>
                    <SectionBlockSubtitle>
                        {formatMessage(homeMessages.membershipVisitsDescription)}
                    </SectionBlockSubtitle>
                </div>

                {isError ? (
                    <GeneralMessageBlock className="py-3" variant="error" />
                ) : (
                    <>
                        <div className="flex w-full justify-center gap-5 text-xs">
                            <StatisticValue
                                title={formatMessage(homeMessages.visits)}
                                value={membershipVisits?.visits_count}
                                isLoading={isLoading}
                            />
                            <StatisticValue
                                title={formatMessage(homeMessages.members)}
                                value={membershipVisits?.members_count}
                                isLoading={isLoading}
                            />
                        </div>
                        <ComparisonBadge value={membershipVisits?.compared_to_last_day} />
                    </>
                )}
                <ComparisonBadge value={membershipVisits?.compared_to_last_day} />
            </GeneralBlock>
        </div>
    );
}
